import { gql } from 'apollo-boost';

export const freelancersListItemFragment = gql`
    fragment FreelancersListItemFragment on GdFreelancerBase {
        freelancerId
        login
        card {
            avatarUrl
            briefInfo
        }
        fio
        rating
        mainSkill {
            days
            price
            duration
        }
        skills {
            name
        }
        status
        workCurrency
        feedbackCount
        region(lang: $lang) {
            translation {
                region
                country
            }
        }
    }
`;

export const freelancerFeedbackFragment = gql`
    fragment FreelancerFeedbackQueryFragment on GdFreelancerFeedback {
        authorInfo {
            avatarUrl
            login
            name
            userId
        }
        authorUid
        createdTime
        feedbackId
        feedbackText
        freelancerId
        overallMark
        willRecommend
        moderationStatus
    }
`;

export const freelancerContactsFragment = gql`
    fragment FreelancerContactsFragment on GdFreelancerContacts {
        siteUrl
        whatsApp
        phone
        icq
        telegram
        email
        viber
        skype
    }
`;

export const freelancerPublicOperatorFragment = gql`
    fragment FreelancerPublicOperatorFragment on Query {
        operator {
            clientId
            login
        }
    }
`;

export const freelancersListQuery = gql`
    query FreelancersListQuery($lang: GdLanguageInput!) {
        freelancersList {
            ...FreelancersListItemFragment
        }
        ...FreelancerPublicOperatorFragment
        reqId: getReqId
    }
    ${freelancersListItemFragment}
    ${freelancerPublicOperatorFragment}
`;

export const freelancerPublicQuery = gql`
    query FreelancerPublicQuery($freelancerLogin: String!, $lang: GdLanguageInput!) {
        reqId: getReqId
        freelancersList(filter: { logins: [$freelancerLogin] }) {
            freelancerId
            fio
            login
            workCurrency
            status
            rating
            certificates {
                certId
                type
                link
            }
            skills {
                name
                skillId
                duration
                priceMoney {
                    valueAsFloat
                }
            }
            card {
                briefInfo
                avatarUrl
                contacts {
                    ...FreelancerContactsFragment
                }
            }
            feedbacks {
                ...FreelancerFeedbackQueryFragment
            }
            mainSkill {
                days
                duration
                name
                priceMoney {
                    valueAsFloat
                }
            }
            region(lang: $lang) {
                translation {
                    region
                    country
                }
            }
        }
        ...FreelancerPublicOperatorFragment
    }
    ${freelancerFeedbackFragment}
    ${freelancerContactsFragment}
    ${freelancerPublicOperatorFragment}
`;
